import { BsSquareHalf, BsSearch, BsTrash } from "react-icons/bs";
// import { IoMdCall, IoMdVideocam } from "react-icons/io";
// import { MdHistory, MdFavorite } from "react-icons/md";

export const listOptionsDiscussion = [
  // <BsSearch />,
  // <IoMdCall />,
  // <IoMdVideocam />,
  // <MdFavorite />,
  // <BsTrash />,
  // <MdHistory />,
  <BsSquareHalf />,
];
